module.exports = __webpack_public_path__ + "img/45.a2806e88.jpg";